import React from 'react';
import { useApp } from '../context/AppContext';
import { Clock, ArrowRight, Sparkles, Leaf, Trash2 } from 'lucide-react';

const HistoryScreen = () => {
  const { scanHistory, setCurrentProduct, setCurrentScreen, clearHistory } = useApp();

  const handleViewScan = (scan) => {
    sessionStorage.setItem('currentScanResult', JSON.stringify(scan));
    setCurrentProduct(scan);
    setCurrentScreen('results-canva');
  };

  if (scanHistory.length === 0) {
    return (
      <div className="min-h-screen bg-white pb-24 flex flex-col">
        {/* Header */}
        <div className="px-6 pt-10 pb-4">
          <p className="text-xs uppercase tracking-[0.2em] text-black/55 mb-2 font-bold">PAST SCANS</p>
          <h1 className="text-2xl font-bold text-black uppercase tracking-wide">
            History
          </h1>
          <p className="text-black/55 text-sm font-normal mt-1">
            Your garment analysis record
          </p>
        </div>

        {/* Empty State */}
        <div className="flex-1 flex flex-col items-center justify-center px-6">
          <div className="w-20 h-20 bg-black/5 rounded-3xl flex items-center justify-center mb-5">
            <Clock size={28} strokeWidth={1.5} className="text-black/55" />
          </div>
          <h2 className="text-xl font-bold text-black text-center mb-2 uppercase">
            No History Yet
          </h2>
          <p className="text-black/55 text-center text-sm font-normal max-w-[280px] leading-relaxed">
            Your scanned garments will appear here. Start scanning to build your intelligence history.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pb-24">
      {/* Header */}
      <div className="px-6 pt-10 pb-4 flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-black/55 mb-2 font-bold">PAST SCANS</p>
          <h1 className="text-2xl font-bold text-black uppercase tracking-wide">
            History
          </h1>
          <p className="text-black/55 text-sm font-normal mt-1">
            {scanHistory.length} {scanHistory.length === 1 ? 'scan' : 'scans'} recorded
          </p>
        </div>
        <button
          onClick={() => { if (window.confirm('Clear all scan history?')) clearHistory(); }}
          className="mt-2 w-9 h-9 flex items-center justify-center rounded-xl bg-black/5 hover:bg-red-50 hover:text-red-500 transition-all"
        >
          <Trash2 size={16} />
        </button>
      </div>

      {/* History List */}
      <div className="px-6 space-y-3">
        {scanHistory.map((scan, index) => (
          <div
            key={scan.id || index}
            onClick={() => handleViewScan(scan)}
            className="bg-white border border-black/12 rounded-2xl overflow-hidden
              cursor-pointer transform hover:scale-[1.01] transition-all duration-300"
          >
            <div className="flex">
              {(scan.thumbnailUrl || scan.imageUrl) && (
                <img
                  src={scan.thumbnailUrl || scan.imageUrl}
                  alt={scan.name}
                  className="w-24 h-24 object-cover"
                />
              )}
              <div className="p-4 flex-1 min-w-0">
                <p className="text-xs text-black/72 font-bold uppercase tracking-wide">
                  {scan.brand}
                </p>
                <h3 className="text-sm font-bold text-black mt-0.5 truncate">
                  {scan.name}
                </h3>
                
                {/* Scores */}
                <div className="flex gap-3 mt-2">
                  {scan.scores?.fabric && (
                    <div className="flex items-center gap-1">
                      <Sparkles size={12} className="text-black/55" />
                      <span className="text-xs text-black/72 font-semibold">{Math.round(scan.scores.fabric)}</span>
                    </div>
                  )}
                  {scan.scores?.sustainability && (
                    <div className="flex items-center gap-1">
                      <Leaf size={12} className="text-black/55" />
                      <span className="text-xs text-black/72 font-semibold">{Math.round(scan.scores.sustainability)}</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="p-4 flex items-center">
                <ArrowRight size={16} className="text-black/30" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoryScreen;